export enum SubscriptionPlan {
  ENTERPRISE = 'Enterprise',
  DEVELOPER = 'Developer',
  MARKETING = 'Marketing',
  DEVELOPER_FREE = 'Developer Free'
}
